/*
*   Clean up the elements data attribute & class list
*/
function cleanElement(e) {
    const el = e.target;
    const animation = el.getAttribute('data-animate')
    if (animation) {
        el.classList.remove(animation)
        el.removeAttribute('data-animate')
    }
}

function animateElement(el) {
    // Add a listener so when the animation ends we can clean it up
    el.addEventListener('animationend', cleanElement)

    // Add the class to the element
    el.classList.add(el.dataset.animate)
}

function prepareStagger(el) {
    Array.from(el.children).forEach((child, i) => {
        child.style.animationDelay = (i * el.dataset.animateStagger) + 'ms'
    })
}

function observerCallback(entries) {
    entries.forEach(entry => {
        const el = entry.target

        if (entry.isIntersecting) {
            this.unobserve(el)

            if(entry.target.getAttribute('data-animate-stagger')) {
                prepareStagger(el)
            }

            if(entry.target.getAttribute('data-animate')) {
                animateElement(el)
            }
        }
    })
}

export function init() {



    const observerOptions = {
        rootMargin: '-10%'
    }

    const els = document.querySelectorAll('[data-animate], [data-animate-stagger]')
    const observer = new IntersectionObserver(observerCallback, observerOptions)

    els.forEach(el => observer.observe(el))
}
